export const REACT_QUERY_KEYS = {
    profile: "profile",
};
export const INFINITY_CACHE = {
    staleTime: Infinity,
    cacheTime: Infinity,
};
//# sourceMappingURL=reactQueryConstants.js.map